module.exports = __webpack_public_path__ + "img/astral-txt_3.87ca9f0f.svg";